import { FileUploadWUT } from '@wix/form-fields/viewer-wut';

export default FileUploadWUT;
